import { defineMessages } from "react-intl";

export default defineMessages({
  PostalCode: {
    id: "usersprofile.views.amp-users-profile.Postal Code",
    defaultMessage: "Postal Code",
  },
  Province: {
    id: "usersprofile.views.amp-users-profile.Province",
    defaultMessage: "Province",
  },
  Mobile: {
    id: "usersprofile.views.amp-users-profile.Mobile",
    defaultMessage: "Mobile",
  },
  Work: {
    id: "usersprofile.views.amp-users-profile.Work",
    defaultMessage: "Work",
  },
  Home: {
    id: "usersprofile.views.amp-users-profile.Home",
    defaultMessage: "Home",
  },
});
